import { create, tsx } from '@dojo/framework/core/vdom';

import * as css from './ListColumns.m.css';

export interface ListColumnsProperties {
	/**
	 * default = 3
	 */
	columnCount?: 1 | 2 | 3;

	/**
	 * CSS column-gap value
	 */
	columnGap?: string;

	/**
	 * CSS max-width value
	 */
	maxWidth?: string;

	/**
	 * Style of the list, none by default
	 */
	style?: 'none' | 'disc' | 'responsive-disc';

	/**
	 * Left padding, none by default
	 */
	paddingLeft?: 'sm' | 'none';

	/**
	 * Left padding, none by default
	 */
	paddingBottom?: 'sm' | 'none';

	/**
	 * Padding at bottom of each item, none by default
	 */
	itemPaddingBottom?: 'sm' | 'none';
}

const factory = create().properties<ListColumnsProperties>();

/**
 * Create a 3-column `ul`. Children are wrapped in `li` elements. Specify `columnCount` to change the number of columns.
 */
export const ListColumns = factory(function ListColumns({ children, properties }) {
	const {
		columnCount = 3,
		columnGap,
		maxWidth,
		style = 'responsive-disc',
		itemPaddingBottom = 'none',
		paddingLeft = 'none',
		paddingBottom = 'none'
	} = properties();
	const columnClass =
		columnCount === 2 ? css.twoColumns : columnCount === 1 ? css.oneColumn : css.threeColumns;
	const styles: Partial<CSSStyleDeclaration> = {
		columnGap,
		maxWidth
	};

	return (
		<ul
			classes={[
				css.root,
				columnClass,
				style === 'disc' && css.disc,
				style === 'responsive-disc' && css.responsiveDisc,
				paddingLeft === 'sm' && css.paddingLeftSmall,
				paddingBottom === 'sm' && css.paddingBottomSmall
			]}
			styles={styles}
		>
			{children().map((item) => (
				<li classes={itemPaddingBottom === 'sm' && css.itemPaddingBottomSmall}>{item}</li>
			))}
		</ul>
	);
});

export default ListColumns;
